(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["to-v2-shop-all"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.to-shop').forEach(function(section){
  section.querySelectorAll('form').forEach(function(form){
    form.addEventListener('formdata',function(event){
      ['filter.v.price.gte','filter.v.price.lte'].forEach(function(name){if(event.formData.get(name)==='') event.formData.delete(name);});
    });
  });
  var cards=Array.prototype.slice.call(section.querySelectorAll('.to-shop__card'));
  var nav=section.querySelector('[data-to-pagination]');
  var perPage=24;
  var pages=Math.ceil(cards.length/perPage);
  if(!nav||pages<2) return;
  var params=new URLSearchParams(window.location.search);
  var current=Math.min(pages,Math.max(1,parseInt(params.get('view_page')||'1',10)||1));
  cards.forEach(function(card,index){card.hidden=index<(current-1)*perPage||index>=current*perPage;});
  function href(page){var next=new URL(window.location.href);if(page===1){next.searchParams.delete('view_page');}else{next.searchParams.set('view_page',page);}return next.pathname+next.search;}
  var html='';
  if(current>1) html+='<a href="'+href(current-1)+'" aria-label="Previous page">&laquo; Previous</a>';
  for(var page=1;page<=pages;page++) html+=page===current?'<span class="page current" aria-current="page">'+page+'</span>':'<a class="page" href="'+href(page)+'">'+page+'</a>';
  if(current<pages) html+='<a href="'+href(current+1)+'" aria-label="Next page">Next &raquo;</a>';
  nav.innerHTML=html;nav.hidden=false;
});

  } catch(e) { console.error(e); }
})();
})();
